import type { FC } from "react";
import { useState } from "react";

import { IconButton } from "@similarweb/ui-components";

import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";
import { translate } from "app/filters/i18nFilter";
import GrandAccessBanner from "app/pages/sales-intelligence/common-components/GrandAccessBanner/GrandAccessBanner";
import { InlineSuccessBanner } from "app/pages/sales-intelligence/common-components/GrandAccessBanner/InlineSuccessBanner";
import { SI_COUNTRIES_HOOK_ID } from "app/pages/sales-intelligence/constants/common";
import { StyledHookBanner } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/components/CountriesDropdown/styles";

export const HookBanner: FC = () => {
    const [hasRequestedSuccessfully, setHasRequestedSuccessfully] = useState<boolean>(false);

    return (
        <StyledHookBanner>
            {hasRequestedSuccessfully ? (
                <InlineSuccessBanner
                    title={translate("hook_modal.get_feature.success.title")}
                    subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
                />
            ) : (
                <GrandAccessBanner
                    title={translate("si.agent_knowledge_base.modal.country.hook.title")}
                    description={translate("si.agent_knowledge_base.modal.country.hook.subtitle")}
                    iconName="calendar-locked"
                    button={
                        <IconButton
                            type="trial"
                            onClick={() => {
                                requestFeature(SI_COUNTRIES_HOOK_ID);
                                setHasRequestedSuccessfully(true);
                            }}
                            iconName="sparkles"
                        >
                            {translate("si.common.contact_us")}
                        </IconButton>
                    }
                />
            )}
        </StyledHookBanner>
    );
};
